import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { paginationActions } from '../../store/actions'
import moment from 'moment'

const Pagination = (props) => {
  const { totalRecords, pagination, pagesToShow, currentPage } = props

  const [state, setState] = useState({
    totalRecords: totalRecords,
    currentPage,
    start: 0,
    end: 10,
  })

  const [pages, setPages] = useState([])
  const [isBefore, setIsBefore] = useState([])
  const [isAfter, setIsAfter] = useState([])

  useEffect(() => {}, [])

  useEffect(() => {
    const { totalRecords, currentPage, pagesToShow } = props.pagingInfo

    const totalPage = Math.ceil(totalRecords / (pagesToShow ? pagesToShow : 10))

    let page = []
    let start = 1
    let end = 10

    if (currentPage > 10) {
      const m = parseInt(currentPage / 10)
      const n = currentPage % 10

      if (n > 0) {
        // 21...32..
        start = m * 10 + 1
        end = m * 10 + 10
      } else {
        // 10, 20, 30...
        start = currentPage - 9
        end = currentPage
      }
    }

    if (end > totalPage) end = totalPage

    // 이전 다음 버튼 체크
    setIsBefore(start > 10)
    setIsAfter(end < totalPage)

    setState({
      totalRecords: totalRecords,
      currentPage: currentPage,
      pagesToShow: pagesToShow,
      totalPage: totalPage,
      start: start,
      end: end,
    })

    for (let i = start; i <= end; i++) {
      page.push(i)
    }

    setPages(page)
  }, [props.pagingInfo])

  const handleChange = (type) => {
    // type = 'before' 이라면 start보다 이전 페이지 호출
    // type = 'after' 이라면 end보다 이전 페이지 호출
    if (type === 'before') {
      handlePage(state.start - 1)
    } else if (type === 'after') {
      handlePage(state.end + 1)
    }
  }

  const handlePage = (page) => {
    setState({
      ...state,
      currentPage: page,
    })
    props.onChange(page)
  }

  return (
    <React.Fragment>
      <span className="paginate">
        {isBefore && (
          <button className="pre" onClick={() => handleChange('before')} title="이전목록으로" style={{ cursor: 'pointer' }}>
            이전
          </button>
        )}
        {pages.map((page, index) => (
          <button
            key={index}
            className={(state.currentPage ? state.currentPage : 1) === page ? 'active' : ''}
            onClick={() => handlePage(page)}
            title={page + '페이지로'}
            style={{ cursor: 'pointer' }}
          >
            {page}
          </button>
        ))}
        {isAfter && (
          <button className="next" onClick={() => handleChange('after')} title="다음목록으로" style={{ cursor: 'pointer' }}>
            다음
          </button>
        )}
      </span>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    pagination: state.pagination,
    start: state.page?.start,
    end: state.page?.end,
  }
}

const actionCreators = {
  setPage: paginationActions.setPage,
}

export default connect(mapStateToProps, actionCreators)(Pagination)
